import { UICfgGapLevel } from '@canvas-logic/clp-api-types';

/**
 * Maps a UICfgGapLevel to a CSS value using design tokens.
 * Returns undefined for 'auto' or undefined input (use default CSS logic).
 * The returned CSS values reference responsive tokens that scale with container queries.
 */
export const gapLevelToCssValue = (level: UICfgGapLevel | undefined): string | undefined => {
  if (!level || level === 'auto') return undefined;
  switch (level) {
    case 'level-1':
      return 'var(--gap-section)';
    case 'level-2':
      return 'var(--gap-subsection)';
    case 'level-3':
      return 'var(--gap-section-subsection)';
    case 'level-4':
      return '4px';
    case 'level-5':
      return '0px';
    default:
      return undefined;
  }
};
